import React from 'react';

const CusButton = (props: React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  const { children, className, ...otherProps } = props;

  return (
    <button
      className={`bg-transparent rounded-lg ${className}`}
      {...otherProps}
    >
      {children}
    </button>
  );
};

export default CusButton;
